/** Remove duplicate array items. */
export default function removeDuplicates(arr) {
  return [...new Set(arr)]
}
